import React, { useEffect, useRef, useState } from "react";
import { useHistory, useParams, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import actions from "../actions";
import _ from "lodash";
import {
    checkPermission,
    findPrevPathFromBreadCrumpData,
    popBreadCrumpOnPageClose,
    removeAllTags,
    showAlert as showAlertUtil
} from "../../../config/utils";
import Form from "./Form";
import qs from "query-string";
import AssetBand from "../../assetSurveyProject/components/AssetBand";
import Portal from "../../common/components/Portal";
import { RichEditorPopup } from "../../common/components/formFields/RichEditorPopup";
import { FilterSearch } from "../../mobileRecommendation/components/FilterModal/FilterSearch";
import { Band } from "../../recommendations/components/InfoPages/Band";
import { Tooltip } from "react-bootstrap";
import InfoTabs from "../../common/components/InfoTabs";
import SoftCosts from "../../LeaseSoftCosts/SoftCosts";
import { permissions } from "../../../config/permissions";

const LeaseInfo = ({ showEditPage }) => {
    const { id: lease_id, section, tab } = useParams();
    const dispatch = useDispatch();
    const history = useHistory();
    const { getLeaseBuildingByIdResponse, getLeaseDynamicFieldsResponse } = useSelector(state => state.leaseBuildingReducer);
    const [basicDetails, setBasicDetails] = useState({});
    const [staticData, setStaticData] = useState({});
    const [showRichTextPopup, setShowRichTextPopup] = useState({ value: "", label: "", key: "", show: false });
    const [fieldSearch, setFieldSearch] = useState("");
    const [infoTabs] = useState([
        { key: "basicdetails", name: "Basic Details", path: `/buildingLease/leaseInfo/${lease_id}/basicdetails${useLocation()?.search}` },
        { key: "lease-income", name: "Income", path: `/buildingLease/leaseInfo/${lease_id}/lease-income${useLocation()?.search}` },
        { key: "lease-expense", name: "Expense", path: `/buildingLease/leaseInfo/${lease_id}/lease-expense${useLocation()?.search}` }
    ]);

    const query = qs.parse(useLocation()?.search);

    const leaseDetailMainFields = {
        // code: {
        //     label: "Code",
        //     field_type: "string"
        // },
        name: {
            label: "Name",
            field_type: "string"
        },
        description: {
            label: "Description",
            field_type: "string"
        },
        color_code: {
            label: "Color",
            field_type: "color"
        }
    };

    const leaseDetailRestFields = {
        start_date: {
            label: "Start Date",
            field_type: "date"
        },
        end_date: {
            label: "End Date",
            field_type: "date"
        },
        building_description: {
            label: "Building Description",
            field_type: "string",
            accessor: data => data?.building?.description || ""
        },
        building_sf: {
            label: "Building SF",
            field_type: "number",
            accessor: data => (data?.building?.area ? parseInt(data?.building?.area) : ""),
            rules: { thousand_separator: true }
        },
        created_at: {
            label: "Created At",
            field_type: "date_time"
        },
        updated_at: {
            label: "Updated At",
            field_type: "date_time"
        }
    };

    const geoHierarchyFields = {
        region_id: { label: "Region", field_type: "string", value: getLeaseBuildingByIdResponse?.region?.name || "" },
        site_id: { label: "Site", field_type: "string", value: getLeaseBuildingByIdResponse?.site?.name || "" },
        building_id: { label: "Building", field_type: "string", value: getLeaseBuildingByIdResponse?.building?.name || "" }
    };

    const [alertMessage, setAlertMessage] = useState("");

    const showAlert = () => {
        showAlertUtil(alertMessage);
        setTimeout(() => setAlertMessage(""), 3000);
    };
    useEffect(() => {
        alertMessage && showAlert();
    }, [alertMessage]);

    useEffect(() => {
        if (lease_id && (tab === "basicdetails" || section === "edit")) {
            dispatch(actions.getLeaseBuildingsById(lease_id, { building_id: query.bid, project_id: query.pid, client_id: query.cid }));
        }
        if (tab === "basicdetails" || section === "edit" || section === "add") {
            dispatch(actions?.getLeaseBuildingsDynamicFields({ client_id: query?.cid }));
        }
    }, [lease_id, tab]);

    useEffect(() => {
        if (getLeaseDynamicFieldsResponse?.lease_custom_fields) {
            const tempBasicDetails = getLeaseDynamicFieldsResponse?.lease_custom_fields;
            setBasicDetails({ ...tempBasicDetails });
        }
    }, [getLeaseDynamicFieldsResponse?.lease_custom_fields]);
    const leaseMainFields = Object.entries(leaseDetailMainFields).reduce((acc, [key, fieldObj]) => {
        acc[key] = {
            ...fieldObj,
            value: getLeaseBuildingByIdResponse?.[key] ?? ""
        };
        return acc;
    }, {});
    const leaseRestFields = Object.entries(leaseDetailRestFields).reduce((acc, [key, fieldObj]) => {
        acc[key] = {
            ...fieldObj,
            value: fieldObj.accessor ? fieldObj.accessor(getLeaseBuildingByIdResponse) : getLeaseBuildingByIdResponse?.[key] ?? ""
        };
        return acc;
    }, {});

    const sfYearRaw = getLeaseBuildingByIdResponse?.sf_years || {};
    const sfYearEntries = Object.entries(sfYearRaw || {});

    const sfYearMainFields = sfYearEntries.slice(0, 3).reduce((acc, [key, obj]) => {
        acc[key] = {
            label: obj?.label || key,
            field_type: "number",
            value: obj?.value ?? "",
            rules: {
                thousand_separator: true,
                suffix: " SF"
            }
        };
        return acc;
    }, {});

    const sfYearRestFields = sfYearEntries.slice(3).reduce((acc, [key, obj]) => {
        acc[key] = {
            label: obj?.label || key,
            field_type: "number",
            value: obj?.value ?? "",
            rules: {
                thousand_separator: true,
                suffix: " SF"
            }
        };
        return acc;
    }, {});

    const renderRichTextPopup = () => {
        const { label, key, show, value } = showRichTextPopup;
        if (!show) return null;
        return (
            <Portal
                body={
                    <RichEditorPopup
                        value={value}
                        label={label}
                        key={key}
                        onCancel={() => setShowRichTextPopup({ ...showRichTextPopup, value: "", label: "", key: "", show: false })}
                        isReadOnly
                    />
                }
                onCancel={() => setShowRichTextPopup({ ...showRichTextPopup, value: "", label: "", key: "", show: false })}
            />
        );
    };

    return (
        <>
            {renderRichTextPopup()}
            {section === "edit" || section === "add" ? (
                <Form basicDetails={basicDetails} />
            ) : (
                <div className="dtl-sec col-md-12 lease_mng add-recommendation">
                    <div className="region-mng">
                        <InfoTabs infoTabsData={infoTabs} />
                        <div className="d-flex convert-btn-outer">
                            <div className="d-flex"></div>
                        </div>
                        {tab === "basicdetails" ? (
                            <div className="tab-active location-sec recom-sec add-recommendation asset-viewer-outer outer-rcm recommendations">
                                <div className="asset-move-pro otr-edit-delte col-md-12 text-right ed-dl view-narrative-report">
                                    <div className="edit-icn-bx select-st">
                                        <div className="search search-box-asset mr-2  not-draggable">
                                            <FilterSearch
                                                fieldSearch={fieldSearch}
                                                setFieldSearch={setFieldSearch}
                                                fields={Object.values(basicDetails ?? {})?.reduce((acc, item) => {
                                                    acc = [...acc, ...Object.keys(item ?? {})?.map(e => ({ label: item?.[e]?.label }))];
                                                    return acc;
                                                }, [])}
                                            />
                                        </div>
                                    </div>
                                    <div className="edit-icn-container otr-edit-delte">
                                        {checkPermission("forms", permissions.LEASE_MANAGEMENT, "edit") && (
                                            <span
                                                class="edit-icn-bx"
                                                onClick={() => {
                                                    showEditPage(lease_id);
                                                }}
                                            >
                                                <i class="fas fa-pencil-alt"></i> Edit
                                            </span>
                                        )}
                                        <span
                                            class="edit-icn-bx"
                                            onClick={() => {
                                                popBreadCrumpOnPageClose();
                                                history.push(findPrevPathFromBreadCrumpData());
                                            }}
                                        >
                                            <i className="fas fa-window-close"></i> Close
                                        </span>
                                    </div>
                                </div>
                                <div className="col-md-12 detail-recom scorll-flow ">
                                    <div className="cnt-sec">
                                        <div className="d-flex">
                                            <div class="col-md-12 p-0">
                                                <AssetBand
                                                    key={"details"}
                                                    bandKey={"details"}
                                                    band={"Basic Details"}
                                                    mainFields={leaseMainFields}
                                                    restFields={leaseRestFields}
                                                    index={100}
                                                    basicDetails={staticData}
                                                    setShowRichTextPopup={setShowRichTextPopup}
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-12 p-0">
                                            <AssetBand
                                                key={"geo_hierarchy"}
                                                bandKey={"geo_hierarchy"}
                                                band={"Geo Hierarchy"}
                                                mainFields={geoHierarchyFields}
                                                index={102}
                                                basicDetails={{}}
                                                setShowRichTextPopup={setShowRichTextPopup}
                                            />
                                        </div>
                                        {sfYearEntries.length > 0 && (
                                            <div class="col-md-12 p-0">
                                                <AssetBand
                                                    key={"sf_year"}
                                                    bandKey={"sf_year"}
                                                    band={"SF/Year"}
                                                    mainFields={sfYearMainFields}
                                                    restFields={sfYearRestFields}
                                                    index={101}
                                                    basicDetails={{}}
                                                    setShowRichTextPopup={setShowRichTextPopup}
                                                />
                                            </div>
                                        )}
                                        {Object.entries(basicDetails ?? {})
                                            ?.filter(([eachBand, fields]) =>
                                                Object.keys(basicDetails?.[eachBand] ?? {})?.some(each => {
                                                    const isFiltered = (basicDetails?.[eachBand]?.[each]?.label ?? "")
                                                        ?.toLowerCase()
                                                        ?.includes(fieldSearch?.toLowerCase());
                                                    return isFiltered;
                                                })
                                            )
                                            ?.map(([eachBand, fields], index) => {
                                                let restFields = {};
                                                Object.entries(basicDetails ?? {})?.forEach(([bandName, fields]) => {
                                                    Object.entries(fields ?? {})?.forEach(([fieldKey, fieldData]) => {
                                                        const fieldName = fieldData?.field_name;
                                                        if (fieldName) {
                                                            restFields[fieldName] = {
                                                                ...fieldData,
                                                                value: getLeaseBuildingByIdResponse?.dynamic_fields?.[fieldName]?.value
                                                            };
                                                        }
                                                    });
                                                });
                                                if (!Object.keys(restFields || {})?.length) return null;
                                                return (
                                                    <div class="col-md-12 p-0">
                                                        <Band
                                                            bandName={eachBand}
                                                            bandId={eachBand?.split(" ")?.join("_")}
                                                            data={restFields}
                                                            fields={fields}
                                                            // handleBandClick={(band, value) => setShowBand({ ...showBand, [band]: value })}
                                                            isDynamic
                                                        />
                                                    </div>
                                                );
                                            })}
                                    </div>
                                </div>
                            </div>
                        ) : tab === "lease-income" ? (
                            <SoftCosts activeTab={"lease-income"} />
                        ) : tab === "lease-expense" ? (
                            <SoftCosts activeTab={"lease-expense"} />
                        ) : null}
                    </div>
                </div>
            )}
        </>
    );
};

export default LeaseInfo;
